import { WORKING_ORDER } from "constants/action-types";
import { WorkingProductsMeta, WorkingProductsRequestOptions } from "types/working-order/product";
import { AvailabilityMeta, AvailabilityMetaRequestOptions } from "types/working-order/inventory";

export const fetchWorkingProducts = (options: WorkingProductsRequestOptions, meta?: WorkingProductsMeta) => ({
    type: WORKING_ORDER.PRODUCTS.FETCH.START,
    payload: options,
    meta,
});

export const fetchProductsAvailability = (options: AvailabilityMetaRequestOptions, meta?: AvailabilityMeta) => ({
    type: WORKING_ORDER.AVAILABILITY.FETCH.START,
    payload: options,
    meta,
});
